import { render, staticRenderFns } from "./survey-step-highest-triglyceride-level.vue?vue&type=template&id=3edb6510"
import script from "./survey-step-highest-triglyceride-level.vue?vue&type=script&lang=js"
export * from "./survey-step-highest-triglyceride-level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports